import axios from "axios";
import DefaultGetConfig from "../../../../utils/defaultGetConfig";

function getMotoVersions(authObj, marca, anio) {
    let carVersionConfig = DefaultGetConfig(authObj)
    carVersionConfig.params = {
        ...carVersionConfig.params,
        marca: marca,
        anio: anio
    }
    let carVersionsUrl = process.env.REACT_APP_BACK_SERVER + '/getVersionesMotos'
    return axios.get(carVersionsUrl, carVersionConfig);
}

export default getMotoVersions;